import {notification} from 'antd';
import {toLogin} from '../commons/index';

/**
 * 尝试获取错误信息 errorTio > resData.message > resData.data > error.message > '未知系统错误'
 * @param error
 * @returns {*}
 */
function getErrorTip({error}) {
    const serverErrorTip = '系统开小差了，请稍后再试或联系管理员';
    // 后端返回数据规范不同，这里可能需要修改
    if (error) {
        const {code, message, data} = error;
        // 后端自定义信息
        if (message && typeof message === 'string') return message;
    }
    if (error && error.message && error.message.startsWith('timeout of')) return '访问资源超时';
    if (error?.message) return error.message;
    return serverErrorTip;
}

export default function handleError({error, errorTip}) {
    const status = error?.code || {};
    // 如果是未登录问题，不显示错误提示，直接跳转到登录页面
    if (status === 401) return toLogin();

    // 用户设置false，关闭提示，不显示错误信息
    if (errorTip && errorTip === false) return;

    const description = getErrorTip({error, errorTip});

    notification.error({
        message: '失败',
        description,
        duration: 2,
    });
}
